import React, { useState } from "react"
import Button from "@/components/core/Button/Button"
import Input from "@/components/core/Input/Input"
import { getTranslations } from "@/components/cart/LookUpCart/localization"
import { useTranslation } from "next-i18next"
import { getCurrency } from "@/utils/helper"
import { setCustomerCartId, removeCustomerCartId } from "@/utils/cart"
import { createCart, getCart } from "@/store/features/cartSlice"
import { useDispatch, useSelector } from "react-redux"
import { selectAuthState } from "@/store/features/authSlice"
import Style from "@/components/cart/LookUpCart/inxed.module.scss"
import { addAnalyticsCollabrativeCart } from "@/components/cart/analytics"

const LookUpCart = () => {
  const [isBtnDisabled, setIsBtnDisabled] = useState(true)
  const [customerCartKey, setCustomerCartKey] = useState("")
  const [error, setError] = useState("")
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const { user: { sub: userEmail } = {} } = useSelector(selectAuthState)
  const dispatch = useDispatch()

  const {
    collabrativeCartDecs = "",
    customersCartID = "",
    LoadCart = "",
    or: orText = "",
    createcart = "",
    invalidcartidError,
  } = staticText

  const handleChange = e => {
    const { value } = e.target
    const textLenght = value.length
    setError("")
    if (textLenght <= 9) {
      setCustomerCartKey(value)
      setIsBtnDisabled(textLenght !== 9)
    }
  }

  const handleCreateCart = () => {
    addAnalyticsCollabrativeCart(createcart?.toLowerCase())
    getCurrency().then(currency => {
      const cartPayload = {
        customerEmail: userEmail,
        currency: currency,
        taxMode: "ExternalAmount",
      }
      removeCustomerCartId()
      dispatch(createCart(cartPayload))
    })
  }

  const handleLoadCart = () => {
    addAnalyticsCollabrativeCart(LoadCart?.toLowerCase())
    dispatch(getCart({ klId: customerCartKey }))
      .unwrap()
      .then(res => {
        setCustomerCartId(res.id)
      })
      .catch(error => {
        setError(invalidcartidError)
      })
  }

  return (
    <div className={Style.cartIsfcUser}>
      <div className="cart-ifsc-section">
        <div className="isfc-description">{collabrativeCartDecs}</div>
        <div className="isfc-cart__input-group">
          <Input
            id="customers-cart-id"
            type="text"
            label={customersCartID}
            value={customerCartKey}
            showError={error}
            errorMessage={error}
            onChange={handleChange}
          />
          <Button
            role="button"
            tabIndex="0"
            label={LoadCart}
            size="large"
            type="black"
            className="cart-load"
            disabled={isBtnDisabled}
            onClick={handleLoadCart}
          />
          <div className="btn-group">
            <div className="middle-or">{orText}</div>
            <Button
              className={"create-cart-button"}
              role="button"
              tabIndex="0"
              label={createcart}
              size="large"
              type="ghost"
              onClick={handleCreateCart}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LookUpCart
